import { useContext } from "react";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import ShopContext from "../../../context/ShopContext";
import AuthService from "../../../services/AuthService";
import { ContactSupportTeamWhatsapp } from "../../utils/ContactSupportTeam";
import WarningIcon from "../../../images/svg/alert-02.svg";

const SubscriptionExpired = () => {
  const navigate = useNavigate();
  const { selectedShop } = useContext(ShopContext);

  const logoutHandler = async () => {
    await AuthService.logout();
    navigate("/login");
  };

  const reloadHandler = () => {
    window.location.reload();
  };

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.iconContainer}>
        <div className={styles.iconWrapper}>
          <img src={WarningIcon} alt="Warning" className={styles.warningIcon} />
        </div>
        <div className={styles.textContainer}>
          <h1 className={styles.title}>Subscription Expired</h1>
          <p className={styles.planName}>{selectedShop?.subscription?.name}</p>
        </div>
      </div>
      <div className={styles.messageContainer}>
        <p className={styles.message}>
          Your plan has expired. Renew now to continue enjoying uninterrupted access to all features.
        </p>
      </div>
      <button className={styles.renewBtn} onClick={() => window.open("https://sanoft.com/pricing", "_blank")}>
        Renew Plan
      </button>

      <button className={styles.supportBtn} onClick={ContactSupportTeamWhatsapp}>
        Contact Support
      </button>

      <div className={styles.footerLinks}>
        <span>Are you sure you want to </span>
        <button className={styles.linkBtn} onClick={logoutHandler}>
          logout?
        </button>
      </div>

      <div className={styles.footerLinks}>
        <button className={styles.linkBtn} onClick={reloadHandler}>
          Reload?
        </button>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
